var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect } from 'react';
import { CustomInput } from 'reactstrap';
import { mapToCssModules } from '../../utils/className';
export const SmlsCheckbox = (_a) => {
    var { id = '', idLabel, checked, onChange, onClick, name = '', label = '', iconUndefined, className, isError = false, errorMessage, dark, value } = _a, params = __rest(_a, ["id", "idLabel", "checked", "onChange", "onClick", "name", "label", "iconUndefined", "className", "isError", "errorMessage", "dark", "value"]);
    useEffect(() => {
        if (id && idLabel) {
            const arrLabelHtml = document.querySelectorAll(`[for=${id}]`);
            if (arrLabelHtml.length > 1) {
                return console.error(`Duplicated id on ${id}, this is a problem, please fix it`);
            }
            arrLabelHtml[0].setAttribute('id', idLabel);
        }
        return undefined;
    }, [id, idLabel]);
    return (React.createElement(CustomInput, Object.assign({ id: id, name: name, onChange: onChange, onClick: onClick, label: label, type: "checkbox", checked: checked, className: mapToCssModules([
            className,
            iconUndefined ? 'smls-chk-undefined' : '',
            !isError ? '' : 'error',
            !errorMessage ? 'without-error' : '',
            !dark ? '' : 'dark',
            'custom-checkbox',
        ]), value: value }, params),
        errorMessage ? (React.createElement(React.Fragment, null,
            React.createElement("br", null),
            React.createElement("span", { className: `smls-chk-error ${dark && 'dark'}` }, errorMessage))) : null,
        React.createElement("div", { className: "smls-chk-out" })));
};
//# sourceMappingURL=index.js.map